import {Variable} from '../../models/variable';
import {AssessmentResult} from '../../../shared/models/assessment-result';
import { Component, OnInit } from '@angular/core';
import { IReportItemComponent } from 'app/reports/models/i-report-item-component';
import { Assessment } from 'app/shared/models/assessment';
import { BaseReportItemComponent } from '../../models/base-report-item-component';

@Component({
  selector: 'dac-assessment-questions-list',
  templateUrl: './assessment-questions-list.component.html',
  styleUrls: ['./assessment-questions-list.component.scss']
})
export class AssessmentQuestionsListComponent extends BaseReportItemComponent implements OnInit, IReportItemComponent {
  private _title: string;

  private _assessment: Assessment;
  public description:string;
  
  constructor() { 
    super();
  }

  ngOnInit() {
  }

  public get assessment() : Assessment {
    return this._assessment;
  }

  setReportData(data: any, results: AssessmentResult[], variables: Variable[]) {
    
    if (data.assessment && results) {
      let assessmentResult = results.find(r => r.assessment.uid == data.assessment);
      this._assessment = assessmentResult ? assessmentResult.assessment : null;
    }
    if (data.title) {
      this._title = data.title;
    }
    else {
      this._title = this._assessment.name;
    }
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  getTitle() {
    return this._title;
  }

  public getQuestionsForAssessment() {
    if (!this._assessment) {
      return [];
    }

    let questions = this._assessment.question_sets
                      .map(qs => qs.questions)
                      .reduce((a,b) => a.concat(b), []);
    return questions;
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/report-items/assessment-questions-list/assessment-questions-list.component.ts